/**
 * useDateRange Hook
 * Date range state management
 */

import { useState, useCallback } from 'react';

const getDefaultRange = () => {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - 7);

  return {
    from: from.toISOString().split('T')[0],
    to: to.toISOString().split('T')[0],
  };
};

const useDateRange = (initialRange) => {
  const [range, setRange] = useState(initialRange || getDefaultRange());

  const onChange = useCallback(({ from, to }) => {
    setRange({ from, to });
  }, []);

  const reset = useCallback(() => {
    setRange(getDefaultRange());
  }, []);

  return {
    from: range.from,
    to: range.to,
    onChange,
    reset,
  };
};

export default useDateRange;
